module.exports = __webpack_public_path__ + "static/media/arrow-square-right.d9941c8a.svg";